import axiosIns from '@/plugins/axios'

export default {
  getUserSystemFlags() {
    return axiosIns.get('/v2/employee/user_management/user_system_flags')
  },
}
